<script>
const sexs = [
  { value: '1', label: '先生' },
  { value: '0', label: '女士/小姐' }
]

const platforms = [
  { value: 1, label: '亚马逊' },
  { value: 2, label: '速卖通' },
  { value: 3, label: 'ebay' },
  { value: 4, label: 'wish' },
  { value: 5, label: '敦煌' },
  { value: 6, label: 'lazada' }
]

const branchesnatures = ['自营', '加盟', '合作', '股份']
const branchesstates = ['正常', '关闭', '盘算', '休业', '假期', '异常']

const businessTypes = [
  { value: 1, label: '电商' },
  { value: 2, label: '物流' },
  { value: 3, label: '仓储' }
]

const Currencys = ['美金', '人民币', '港币', '葡币', '欧元', '英镑', '日元', '新加坡元', '卢布', '瑞士法郎', '澳元', '加元', '瑞典克朗']

const pagesizes = [100, 500, 1000, 5000]

const openEmsUrl = 'http://ems.etport.com'
// const openEmsUrl = '/ems'
// const openEmsUrl = 'http://localhost:7252'
const openTmsUrl = 'http://localhost:7253'
const openWmsUrl = 'http://localhost:7252'

const openPaths = {
  //用户
  login: openEmsUrl + '/api/user/UserLogin',//用户登录
  existsSingleLogin: openEmsUrl + '/api/user/ExistsSingleUser',//验证用户登录状态
  exitLogin: openEmsUrl + '/api/user/ExitLogin',//退出登录
  existsLoginName: openEmsUrl + '/api/user/ExistsLoginName',//验证用户登录名
  existsEmail: openEmsUrl + '/api/user/ExistsEmail',//验证邮箱
  sendRegisterEmail: openEmsUrl + '/api/user/SendEmailRegister',//发送注册邮件
  registerEmailSCodeValidate: openEmsUrl + '/api/user/RegisterEmailSCodeValidate',//验证注册邮件验证码
  existsRegisterMobilePhone: openEmsUrl + '/api/user/ExistsMobilePhone',//验证手机号码
  registerSubmit: openEmsUrl + '/api/user/RegisterSubmit',//注册提交
  getUserMenus: openEmsUrl + '/api/user/GetUserMenuList',//获取用户菜单
  getCurrentUserInfo: openEmsUrl + '/api/user/GetUserInfo',//获取用户信息
  submitUserInfo: openEmsUrl + '/api/user/UpdateUserInfo',//更新用户信息
  getCurrentUserSafe: openEmsUrl + '/api/user/GetUserSafeInfo',//获取个人安全信息
  sendUserSafeEmail: openEmsUrl + '/api/user/SendSafeEmail',//发送修改邮件验证码
  submitUserSafeEmail: openEmsUrl + '/api/user/UpdateUserSafeEmail',//修改密保邮箱
  insertUserModel: openEmsUrl + '/api/user/Insert',
  updateUserModel: openEmsUrl + '/api/user/Update',
  deleteUserModel: openEmsUrl + '/api/user/Delete',
  searchUserPager: openEmsUrl + '/api/user/SearchPager',
  loadUserMenus: openEmsUrl + '/api/user/GetMenuList',
  loadUserFunctions: openEmsUrl + '/api/user/GetFunctionList',
  settingUserPower: openEmsUrl + '/api/user/SettingPower',
  //企业
  existsRegisterEnterpriseName: openEmsUrl + '/api/enterprise/ExistsEnterpriseName',//验证企业名
  existsRegisterUnifySocialCreditCode: openEmsUrl + '/api/enterprise/ExistsUnifySocialCreditCode',//验证统一社会信用代码
  getEnterpriseInfo: openEmsUrl + '/api/enterprise/GetEnterpriseInfo',//获取企业信息
  enterpriseFileUpload: openEmsUrl + '/api/enterprise/UploadEnterpriseFile',//上传企业文件
  updateEnterpriseInfo: openEmsUrl + '/api/enterprise/UpdateEnterpriseModel',//修改企业信息
  getEnterpriseMenus: openEmsUrl + '/api/enterprise/GetMenuList',//获取企业菜单
  getEnterpriseFunctions: openEmsUrl + '/api/enterprise/GetFunctionList',//获取企业功能
  searchEnterpriseList: openEmsUrl + '/api/enterprise/SearchEnterpriseList',
  //网点
  searchBranchesPager: openEmsUrl + '/api/branches/SearchPager',//分页查询网点
  insertBranchesModel: openEmsUrl + '/api/branches/Insert',//添加网点
  updateBranchesModel: openEmsUrl + '/api/branches/Update',//修改网点
  deleteBranchesModel: openEmsUrl + '/api/branches/Delete',//删除网点
  existsBranchesCode: openEmsUrl + '/api/branches/ExistsCode',//验证网点代码
  searchBranchesAll: openEmsUrl + '/api/branches/SearchAll',//获取全部网点
  getBranchesModel: openEmsUrl + '/api/branches/GetModel',//获取网点
  //部门
  existsDepartmentName: openEmsUrl + '/api/department/ExistsName',
  insertDepartment: openEmsUrl + '/api/department/Insert',
  updateDepartment: openEmsUrl + '/api/department/Update',
  deleteDepartment: openEmsUrl + '/api/department/Delete',
  searchDepartmentAll: openEmsUrl + '/api/department/SearchAll',
  searchDepartmentPager: openEmsUrl + '/api/department/SearchPager',
  searchDepartmentModel: openEmsUrl + '/api/department/GetModel',
  //职位
  existsPositionName: openEmsUrl + '/api/position/ExistsName',
  insertPosition: openEmsUrl + '/api/position/Insert',
  updatePosition: openEmsUrl + '/api/position/Update',
  deletePosition: openEmsUrl + '/api/position/Delete',
  searchPositionAll: openEmsUrl + '/api/position/SearchAll',
  searchPositionPager: openEmsUrl + '/api/position/SearchPager',
  searchPositionModel: openEmsUrl + '/api/position/GetModel',
  getPositionMenus: openEmsUrl + '/api/position/GetMenuList',
  getPositionFunctions: openEmsUrl + '/api/position/GetFunctionList',
  settingPositionPower: openEmsUrl + '/api/position/SettingPower',
  //渠道
  getCarriersList: openTmsUrl + '/api/channel/GetCarriersList',
  getFeeTypeList: openTmsUrl + '/api/channel/GetFeeTypeList',
  existsChannelCode: openTmsUrl + '/api/channel/ExistsChannelCode',
  existsChannelName: openTmsUrl + '/api/channel/ExistsChannelName',
  searchChannelPager: openTmsUrl + '/api/channel/SearchPager',
  insertChannel: openTmsUrl + '/api/channel/Insert',
  updateChannel: openTmsUrl + '/api/channel/Update',
  deleteChannel: openTmsUrl + '/api/channel/Delete',
  restoreChannel: openTmsUrl + '/api/channel/Restore',
  getCountryList: openTmsUrl + '/api/channel/GetCountryList',
  getAirportList: openTmsUrl + '/api/channel/GetAirportList',
  getPortList: openTmsUrl + '/api/channel/GetPortList',
  getFBADepotList: openTmsUrl + '/api/channel/GetFBADepotList',
  getChannelList: openTmsUrl + '/api/channel/SearchEnterpriseChannel',
  importChannelOdd: openTmsUrl + '/api/channel/ImportChannelOdd',
  searchChannelOddPager: openTmsUrl + '/api/channel/SearchOddPoolPager',
  exportChannelOdd: openTmsUrl + '/api/channel/ExportChannelOdd',
  deleteChannelOdd: openTmsUrl + '/api/channel/DeleteChannelOdd',
  useChannelOdd: openTmsUrl + '/api/channel/UseChannelOdd',
  recoveryChannelOdd: openTmsUrl + '/api/channel/RecoveryChannelOdd',
  //线路
  existsChannelLineCode: openTmsUrl + '/api/channelline/ExistsChannelLineCode',
  existsChannelLineName: openTmsUrl + '/api/channelline/ExistsChannelLineName',
  insertChannelLine: openTmsUrl + '/api/channelline/Insert',
  updateChannelLine: openTmsUrl + '/api/channelline/Update',
  deleteChannelLine: openTmsUrl + '/api/channelline/Delete',
  searchChannelLine: openTmsUrl + '/api/channelline/SearchChannelLineList',
  searchChannelLinePager: openTmsUrl + '/api/channelline/SearchPager',
  importChannelLine: openTmsUrl + '/api/channelline/ImportChannelLine',
  exportChannelLine: openTmsUrl + '/api/channelline/ExportChannelLine',
  searchChannelLinePurpose: openTmsUrl + '/api/channelline/SearchChannelLinePurpose',
  //价格版本
  insertChannelPriceVersion: openTmsUrl + '/api/channelprice/InertVersion',
  updateChannelPriceVersion: openTmsUrl + '/api/channelprice/UpdateVersion',
  deleteChannelPriceVersion: openTmsUrl + '/api/channelprice/DeleteVersion',
  searchChannelPriceVersion: openTmsUrl + '/api/channelprice/SearchVersionList',
  //渠道价格
  insertChannelPrice: openTmsUrl + '/api/channelprice/Insert',
  updateChannelPrice: openTmsUrl + '/api/channelprice/Update',
  deleteChannelPrice: openTmsUrl + '/api/channelprice/Delete',
  searchChannelPrice: openTmsUrl + '/api/channelprice/SearchPriceList',
  importChannelPrice: openTmsUrl + '/api/channelprice/ImportChannelPrice',
  //渠道供应商
  existsChannelSupplyName: openTmsUrl + '/api/channelsupply/ExistsChannelSupplyName',
  existsChannelSupplyCode: openTmsUrl + '/api/channelsupply/ExistsChannelSupplyCode',
  insertChannelSupply: openTmsUrl + '/api/channelsupply/Insert',
  updateChannelSupply: openTmsUrl + '/api/channelsupply/Update',
  deleteChannelSupply: openTmsUrl + '/api/channelsupply/Delete',
  searchChannelSupplyPager: openTmsUrl + '/api/channelsupply/SearchPager',
  searchEnterpriseChannelSupply: openTmsUrl + '/api/channelsupply/SearchEnterpriseChannelSupply',
  //供应商折扣
  insertChannelSupplyDiscountVersion: openTmsUrl + '/api/channelsupplydiscount/InsertVersion',
  updateChannelSupplyDiscountVersion: openTmsUrl + '/api/channelsupplydiscount/UpdateVersion',
  deleteChannelSupplyDiscountVersion: openTmsUrl + '/api/channelsupplydiscount/DeleteVersion',
  searchChannelSupplyDiscountVersion: openTmsUrl + '/api/channelsupplydiscount/SearchVersionList',


  DepartmentSubmit: openEmsUrl + '/api/enterprise/DepartmentSubmit',//部门提交
  DepartmentPager: openEmsUrl + '/api/enterprise/DepartmentPager',//部门分页查询
  DepartmentDelete: openEmsUrl + '/api/enterprise/DepartmentDelete',//部门删除
  DepartmentList: openEmsUrl + '/api/enterprise/DepartmentList',//部门列表
  PositionSubmit: openEmsUrl + '/api/enterprise/PositionSubmit',//职位提交
  PositionPager: openEmsUrl + '/api/enterprise/PositionPager',//职位分页
  PositionDelete: openEmsUrl + '/api/enterprise/PositionDelete',//职位删除
  PositionList: openEmsUrl + '/api/enterpeise/PositionList',//职位列表
  fileupload: openEmsUrl + '/api/file/upload',//上传文件
  halfyearwaybilltotal: openTmsUrl + '/api/waybill/halfyeartotal',//半年内数量
  notobtainwaybilltotal: openTmsUrl + '/api/waybill/notobtaintotal',//未抓单数量
  obtainwaybilltotal: openTmsUrl + '/api/waybill/obtaintotal',//已抓单数量
  collectwaybilltotal: openTmsUrl + '/api/waybill/collecttotal',//已揽件数量
  transportwaybilltotal: openTmsUrl + '/api/waybill/transporttotal',//运输中数量
  problemwaybilltotal: openTmsUrl + '/api/waybill/problemtotal',//问题件数量
  stagingwaybilltotal: openTmsUrl + '/api/waybill/stagingtotal',//暂存件数量
  recycletotal: openTmsUrl + '/api/waybill/recycletotal',//已删除数量
}

const linkpaths = {
  viplevelpath: '/'
}

const oddtypes = [
  { value: 'customerodd', label: '客户单号' },
  { value: 'serviceodd', label: '服务商单号' },
  { value: 'turnodd', label: '转单号' },
  { value: 'trackodd', label: '追踪单号' },
]

const waybilltimetypes = [
  { value: 'firstedittime', label: '创建时间' },
  { value: 'confirmtime', label: '抓单时间' },
  { value: 'putstoragetime', label: '揽件时间' },
  { value: 'outboundtime', label: '发件时间' },
]

const waybillproblemtimetypes = [
  { value: 'firstedittime', label: '创建时间' },
  { value: 'confirmtime', label: '抓单时间' },
  { value: 'putstoragetime', label: '揽件时间' },
  { value: 'outboundtime', label: '发件时间' },
  { value: 'launchtime', label: '发起时间' },
]

const waybillstates = [
  { value: 'notobtain', label: '未抓单' },
  { value: 'obtain', label: '已抓单' },
  { value: 'collect', label: '已揽件' },
  { value: 'transport', label: '运输中' },
  { value: 'problem', label: '问题件' },
  { value: 'staging', label: '暂存件' },
  { value: 'recycle', label: '回收站' }
]

const waybillprintstates = [
  { value: '1', label: '已打印' },
  { value: '0', label: '未打印' }
]

const taglist = [
  {
    value: 'halfyear',
    label: '半年内运单',
    url: openPaths.halfyearwaybilltotal,
    totalnum: 0,
    class: 'active'
  },
  {
    value: 'notobtain',
    label: '未抓单',
    url: openPaths.notobtainwaybilltotal,
    totalnum: 0,
    class: ''
  },
  {
    value: 'obtain',
    label: '已抓单',
    url: openPaths.obtainwaybilltotal,
    totalnum: 0,
    class: ''
  },
  {
    value: 'collect',
    label: '已揽收',
    url: openPaths.collectwaybilltotal,
    totalnum: 0,
    class: ''
  },
  {
    value: 'transport',
    label: '运输中',
    url: openPaths.transportwaybilltotal,
    totalnum: 0,
    class: ''
  },
  {
    value: 'work',
    label: '工单件',
    url: openPaths.problemwaybilltotal,
    totalnum: 0,
    class: ''
  },
  {
    value: 'staging',
    label: '暂存件',
    url: openPaths.stagingwaybilltotal,
    totalnum: 0,
    class: ''
  },
  {
    value: 'recycle',
    label: '回收站',
    url: openPaths.recycletotal,
    totalnum: 0,
    class: ''
  }
]

const waybillcolumns = [
  { label: '客户单号', value: 'customerodd', checked: false, customcolumn: '' },
  { label: '服务商单号', value: 'ServiceOdd', checked: false, customcolumn: '' },
  { label: '发货商', value: 'TargetEnterprise', checked: false, customcolumn: '' },
  { label: '渠道', value: 'Channel', checked: false, customcolumn: '' },
  { label: '包裹分类', value: 'ParcelType', checked: false, customcolumn: '' },
  { label: '是否退件', value: 'NeedReturn', checked: false, customcolumn: '' },
  { label: '数量', value: 'ConfirmQuantity', checked: false, customcolumn: '' },
  { label: '箱号', value: 'CaseNumber', checked: false, customcolumn: '' },
  { label: '子单号', value: 'ParcelOdd', checked: false, customcolumn: '' },
  { label: '重量', value: 'ParcelConfirmWeight', checked: false, customcolumn: '' },
  { label: '长', value: 'ParcelConfirmLong', checked: false, customcolumn: '' },
  { label: '宽', value: 'ParcelConfirmWide', checked: false, customcolumn: '' },
  { label: '高', value: 'ParcelConfirmHigh', checked: false, customcolumn: '' },
  { label: '收货人', value: 'ReceiptName', checked: false, customcolumn: '' },
  { label: '收货公司', value: 'ReceiptCompanyName', checked: false, customcolumn: '' },
  { label: '目的国家', value: 'PurposeRegion', checked: false, customcolumn: '' },
  { label: '目的机场 港口 仓库', value: 'PurposeAirPortDepot', checked: false, customcolumn: '' },
  { label: '目的州省', value: 'ReceiptState', checked: false, customcolumn: '' },
  { label: '目的城市', value: 'ReceiptCity', checked: false, customcolumn: '' },
  { label: '目的区县', value: 'ReceiptCounty', checked: false, customcolumn: '' },
  { label: '目的街道', value: 'ReceiptStreet', checked: false, customcolumn: '' },
  { label: '收货详细地址', value: 'ReceiptAddress', checked: false, customcolumn: '' },
  { label: '收货备用地址', value: 'ReceiptStandbyAddress', checked: false, customcolumn: '' },
  { label: '收货方手机', value: 'ReceiptMobile', checked: false, customcolumn: '' },
  { label: '收货方电话', value: 'ReceiptPhone', checked: false, customcolumn: '' },
  { label: '收货方传真', value: 'ReceiptFax', checked: false, customcolumn: '' },
  { label: '收货方邮编', value: 'BuyerZipcode', checked: false, customcolumn: '' },
  { label: '收货方邮箱', value: 'ReceiptEmail', checked: false, customcolumn: '' },
  { label: '平台买家ID', value: 'BuyerCode', checked: false, customcolumn: '' },
  { label: '寄件人', value: 'SenderName', checked: false, customcolumn: '' },
  { label: '寄件公司', value: 'SenderCompanyName', checked: false, customcolumn: '' },
  { label: '寄件州省', value: 'SenderState', checked: false, customcolumn: '' },
  { label: '起运机场 港口 仓库', value: 'ShipmentAirPortDepot', checked: false, customcolumn: '' },
  { label: '寄件城市', value: 'SenderCity', checked: false, customcolumn: '' },
  { label: '寄件区县', value: 'SenderCounty', checked: false, customcolumn: '' },
  { label: '寄件街道', value: 'SenderStreet', checked: false, customcolumn: '' },
  { label: '寄件详细地址', value: 'SenderAddress', checked: false, customcolumn: '' },
  { label: '寄件备用地址', value: 'SenderStandbyAddress', checked: false, customcolumn: '' },
  { label: '寄件人手机', value: 'SenderMobile', checked: false, customcolumn: '' },
  { label: '寄件人电话', value: 'SenderPhone', checked: false, customcolumn: '' },
  { label: '寄件人传真', value: 'SenderFax', checked: false, customcolumn: '' },
  { label: '寄件人邮编', value: 'SenderZipcode', checked: false, customcolumn: '' },
  { label: '寄件人邮箱', value: 'SenderEmaill', checked: false, customcolumn: '' },
  { label: '平台买家ID', value: 'SellerCode', checked: false, customcolumn: '' },
  { label: '中文品名', value: 'DeclareName_CN', checked: false, customcolumn: '' },
  { label: '英文品名', value: 'DeclareName_EN', checked: false, customcolumn: '' },
  { label: '海关编码', value: 'CustomsCode', checked: false, customcolumn: '' },
  { label: '申报数量', value: 'DeclareQuantity', checked: false, customcolumn: '' },
  { label: '申报单价', value: 'DeclareUnitPrice', checked: false, customcolumn: '' },
  { label: '配货信息', value: 'ProductInfo', checked: false, customcolumn: '' },
  { label: '产品SKU', value: 'ProductSKU', checked: false, customcolumn: '' },
  { label: '币种', value: 'Currency', checked: false, customcolumn: '' },
  { label: '税号', value: 'InvoiceTaxno', checked: false, customcolumn: '' },
  { label: '平台产品ID', value: 'PlatformProductId', checked: false, customcolumn: '' },
  { label: '材质', value: 'Material', checked: false, customcolumn: '' },
  { label: '用途', value: 'Purpose', checked: false, customcolumn: '' },
  { label: '产地', value: 'Origin', checked: false, customcolumn: '' },
  { label: '品牌', value: 'Brand', checked: false, customcolumn: '' },
  { label: '规格', value: 'Spec', checked: false, customcolumn: '' },
  { label: '平台产品链接', value: 'ProductLink', checked: false, customcolumn: '' },
  { label: '平台图片链接', value: 'ImageLink', checked: false, customcolumn: '' }
]

const customerbilltypes = [
  { label: '运费账单', value: '0' },
  { label: '返点账单', value: '1' },
  { label: '充值账单', value: '2' },
  { label: '问题账单', value: '3' },
]

const pickerOptions = {
  shortcuts: [{
    value: 7,
    text: '最近一周',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    value: 30,
    text: '最近一个月',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    value: 90,
    text: '最近三个月',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    },
  },
  {
    value: 180,
    text: '最近半年',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
      picker.$emit('pick', [start, end])
    },
  },
  {
    value: 365,
    text: '最近一年',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
      picker.$emit('pick', [start, end])
    },
  }
  ]
}

const effectTimeOptions = {
  shortcuts: [{
    value: 7,
    text: '一周内',
    onClick (picker) {
      const start = new Date()
      const end = new Date()
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    value: 30,
    text: '一个月内',
    onClick (picker) {
      const start = new Date()
      const end = new Date()
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    value: 90,
    text: '三个月内',
    onClick (picker) {
      const start = new Date()
      const end = new Date()
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    },
  },
  {
    value: 180,
    text: '半年内',
    onClick (picker) {
      const start = new Date()
      const end = new Date()
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 180)
      picker.$emit('pick', [start, end])
    },
  },
  {
    value: 365,
    text: '一年内',
    onClick (picker) {
      const start = new Date()
      const end = new Date()
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 365)
      picker.$emit('pick', [start, end])
    },
  }
  ]
}

const ctmsWaybillColumns = [
  { label: '客户', value: 'CustomerId' },
  { label: '客户单号', value: 'CustomerOdd' },
  { label: '服务商单号', value: 'SystemOdd' },
  { label: '追踪单号', value: 'TrackOdd' },
  { label: '渠道', value: 'ChannelName' },
  { label: '包裹类型', value: 'ParcelType' },
  { label: '提交数量', value: 'ConfirmQuantity' },
  { label: '提交重量', value: 'ConfirmTotalWeight' },
  { label: '提交体积', value: 'ConfirmTotalVolume' },
  { label: '提交体积重', value: 'ConfirmTotalVolumeWeight' },
  { label: '抓单时间', value: 'ConfirmTime' },
  { label: '入库数量', value: 'PutStorageQuantity' },
  { label: '入库重量', value: 'PutStorageTotalWeight' },
  { label: '入库体积', value: 'PutStorageTotalVolume' },
  { label: '入库体积重', value: 'PutStorageTotalVolumeWeight' },
  { label: '入库时间', value: 'PutStorageTime' },
  { label: '运单来源', value: 'WaybillSource' },
  { label: '退件状态', value: 'NeedReturnState' },
  { label: '起运国家', value: 'ShipmentRegionName' },
  { label: '起运机场 港口 仓库', value: 'ShipmentAirPortDepotName' },
  { label: '发货人', value: 'SenderName' },
  { label: '目的国家', value: 'PurposeRegionName' },
  { label: '目的机场 港口 仓库', value: 'PurposeAirPortDepotName' },
  { label: '发货人', value: 'ReceiptName' },
  { label: '电商平台备注', value: 'WaybillPlatformNote' },
  { label: '运单备注', value: 'WaybillCustomerNote' },
  { label: '创建时间', value: 'FirstEditTime' }
]

const tmsWaybillColumns = [
  { label: '客户', value: 'CustomerId' },
  { label: '客户单号', value: 'CustomerOdd' },
  { label: '服务商单号', value: 'SystemOdd' },
  { label: '追踪单号', value: 'TrackOdd' },
  { label: '渠道', value: 'ChannelName' },
  { label: '包裹类型', value: 'ParcelType' },
  { label: '提交数量', value: 'ConfirmQuantity' },
  { label: '提交重量', value: 'ConfirmTotalWeight' },
  { label: '提交体积', value: 'ConfirmTotalVolume' },
  { label: '提交体积重', value: 'ConfirmTotalVolumeWeight' },
  { label: '抓单时间', value: 'ConfirmTime' },
  { label: '入库数量', value: 'PutStorageQuantity' },
  { label: '入库重量', value: 'PutStorageTotalWeight' },
  { label: '入库体积', value: 'PutStorageTotalVolume' },
  { label: '入库体积重', value: 'PutStorageTotalVolumeWeight' },
  { label: '入库时间', value: 'PutStorageTime' },
  { label: '渠道供应商', value: 'ChannelSupplyName' },
  { label: '出库数量', value: 'OutboundQuantity' },
  { label: '出库重量', value: 'OutboundTotalWeight' },
  { label: '出库体积', value: 'OutboundTotalVolume' },
  { label: '出库体积重', value: 'OutboundTotalVolumeWeight' },
  { label: '出库时间', value: 'OutboundTime' },
  { label: '运单来源', value: 'WaybillSource' },
  { label: '退件状态', value: 'NeedReturnState' },
  { label: '起运国家', value: 'ShipmentRegionName' },
  { label: '起运机场 港口 仓库', value: 'ShipmentAirPortDepotName' },
  { label: '发货人', value: 'SenderName' },
  { label: '目的国家', value: 'PurposeRegionName' },
  { label: '目的机场 港口 仓库', value: 'PurposeAirPortDepotName' },
  { label: '发货人', value: 'ReceiptName' },
  { label: '电商平台备注', value: 'WaybillPlatformNote' },
  { label: '运单备注', value: 'WaybillCustomerNote' },
  { label: '发货商备注', value: 'WaybillEnterpriseNote' },
  { label: '创建时间', value: 'FirstEditTime' }
]

const channelTypes = [
  { label: '挂号', value: 1 },
  { label: '平邮', value: 2 },
  { label: '快递', value: 3 },
  { label: '专线', value: 4 },
  { label: '海运', value: 5 },
  { label: '空运', value: 6 },
  { label: '陆运', value: 7 },
  { label: '铁路', value: 8 },
  { label: '头程', value: 9 },
]

const billingWays = [
  { label: '称重(kg)', value: 1 },
  { label: '体积(m³)', value: 2 },
  { label: '体积重(kg)', value: 3 },
  { label: '传统(称重、体积重取大)', value: 4 },
  { label: '混合(称重体积重取半)', value: 5 },
  { label: '数量', value: 6 },
]

const parcelCarryTypes = [
  { label: '单包裹进位', value: 1 },
  { label: '总包裹进位', value: 2 },
]

const itemsAttributes = [
  { label: '普货', value: 1 },
  { label: '带电', value: 2 },
  { label: '纯电池', value: 3 },
  { label: '液体', value: 4 },
  { label: '药品', value: 5 },
  { label: '食品', value: 6 },
  { label: '蔬果', value: 7 },
  { label: '粉末', value: 8 },
  { label: '膏体', value: 9 },
  { label: '化妆品', value: 10 },
  { label: '敏感货', value: 11 }
]

const channelDockingTypes = [
  { label: '平台对接', value: 0 },
  { label: 'E邮宝', value: 1 },
  { label: 'E包裹', value: 2 },
  { label: 'E下单', value: 3 },
  { label: '中国邮政', value: 4 },
  { label: 'Wish邮', value: 5 },
  { label: '艾帕奇', value: 6 },
  { label: '华磊', value: 7 },
  { label: '易仓', value: 8 },
  { label: '易宇通', value: 9 },
  { label: 'DHL', value: 10 },
  { label: 'UPS', value: 11 },
]

const linetypes = [
  { label: '地区', value: 1 },
  { label: '机场', value: 2 },
  { label: '港口', value: 3 },
  { label: 'FBA', value: 4 },
  { label: '仓库', value: 5 },
  // { label: '邮编', value: 5 },
]

const itemtypes = [
  { label: '物品', value: 1 },
  { label: '文件', value: 2 },
  { label: '带电', value: 3 },
  { label: '敏感货', value: 11 },
  { label: '20GP', value: 20 },
  { label: '40GP', value: 40 },
  { label: '40HC/HQ(高柜)', value: 41 },
  { label: '45HC/HQ(高柜)', value: 45 },
  { label: '20OT(开顶柜)', value: 21 },
  { label: '40OT(开顶柜)', value: 42 },
  { label: '20FR(脚架式折叠平板)', value: 22 },
  { label: '40FR(脚架式折叠平板)', value: 43 },
  { label: '20Refigerated(冷冻柜)', value: 23 },
  { label: '40Refigerated(冷冻柜)', value: 44 },
]

const commonstates = [
  { label: '停用', value: -1 },
  { label: '正常', value: 1 },
  { label: '已删', value: 99 },
]

const oddstates = [
  { label: '失效', value: 20 },
  { label: '正常', value: 1 }
]

const zonetemplatetypes = [
  { label: '单行', value: 1 },
  { label: '多行', value: 2 },
  { label: '多表单', value: 3 },
]

const priceBillingTypes = [
  { label: '定价', value: 1 },
  { label: '增量', value: 2 },
  { label: '直乘', value: 3 },
  { label: '总乘', value: 4 },
  { label: '百分比', value: 5 },
]

const discountBillingTypes = [
  { label: '定价', value: 1 },
  { label: '增量', value: 2 },
  { label: '直乘', value: 3 },
  { label: '总乘', value: 4 },
  { label: '百分比', value: 5 },
  { label: '折扣', value: 6 }
]

const priceImportTemplates = [
  { label: '横向模版', value: 1 },
  { label: '纵向模版', value: 2 },
  { label: '标准模版', value: 3 },
]

const supplyTypes = [
  { label: '平台物流商', value: 1 },
  { label: '自建供应商', value: 2 },
]

const customerTypes = [
  { label: '平台客户', value: 1 },
  { label: '自建客户', value: 2 },
]

const discountVersionStates = [
  { label: '停用', value: -1 },
  { label: '启用', value: 1 },
]

export default {
  openEmsUrl,
  openTmsUrl,
  sexs,
  platforms,
  businessTypes,
  branchesnatures,
  branchesstates,
  openEmsUrl,
  openPaths,
  linkpaths,
  pagesizes,
  Currencys,
  oddtypes,
  waybilltimetypes,
  waybillproblemtimetypes,
  waybillstates,
  waybillprintstates,
  taglist,
  waybillcolumns,
  customerbilltypes,
  pickerOptions,
  ctmsWaybillColumns,
  tmsWaybillColumns,
  channelTypes,
  billingWays,
  parcelCarryTypes,
  itemsAttributes,
  linetypes,
  itemtypes,
  commonstates,
  oddstates,
  zonetemplatetypes,
  effectTimeOptions,
  priceBillingTypes,
  discountBillingTypes,
  priceImportTemplates,
  supplyTypes,
  channelDockingTypes,
  discountVersionStates,
  customerTypes,
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/common/constant.vue